import './ConnectionIssueConfig';
import ConversationChatIcon from '../../../components/icons/svg/ConversationChatIcon';
import ErrorPage from '../ErrorPage';

const PageConnectionIssue: React.FC = () => (
  <ErrorPage
    translationKey="ConnectionIssue"
    iconComponent={ConversationChatIcon}
    titleKey="TITLE_CONNECTION_ISSUE"
    subtitleKey="SUBTITLE_CONNECTION_ISSUE"
    buttonKey="HOME_BUTTON_CONNECTION_ISSUE"
  />
);

export default PageConnectionIssue;
